module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"DRD event decorations","short_name":"DRD decorations","start_url":"/","background_color":"#f44336","theme_color":"#f44336","display":"standalone","crossOrigin":"use-credentials","icon":"src/images/event-decorations-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"7877db51c05290e7ba6a6954bcf2dc03"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
